import { const_var, params } from "../../../redux/reducers/reducer";
import { makeDimensionUpdateBack, makeDimensionUpdateFront, makeDimensionUpdateLeft, makeDimensionUpdateRight } from "../../lean_building_pricing/leanBuilding.helper";
import { loadDefaultBuilding } from "../load_building/loadBuilding";
import * as cuComponent from "../../../redux/reducers/building_component/componentReducer";
import { setDefaultConfiguration } from "./buildingConfiguration.helper";
import { makeDimensionArray } from "../building_style/centreBuilding.helper";

export const checkOtherBuildingType = (state, action) => {
	state.defaultBuilding = action.defaultVal;

	if (const_var.ExtraBuildingID[action.value] && const_var.ExtraBuildingID[action.value].name?.includes("/12")) {
		const_var.otherBuildingRoofPitch = const_var.ExtraBuildingID[action.value].name.split("/12")[0];
	}
	state.checkedBuildingType = action.value;
	if (const_var.defaultBuildingArr[action.defaultVal].building_id != action.value) {
		if (const_var.defaultBuildingArr[parseInt(action.defaultVal + 1)] == undefined) {
			state.defaultBuilding = parseInt(action.defaultVal + 1);
		}
	}

	if (action.defaultVal != state.OlddefaultBuilding) {
		delete const_var.defaultBuildingArr[parseInt(action.defaultVal)];
		state.defaultBuilding = state.OlddefaultBuilding;
		action.defaultVal = state.OlddefaultBuilding;
	} else if (Object.keys(const_var.holdDefaultBuildingArr).length > 0 && Object.keys(const_var.holdDefaultBuildingArr).length < Object.keys(const_var.defaultBuildingArr).length) {
		let findLastARR = Object.keys(const_var.defaultBuildingArr);
		let findLastIndex = findLastARR[findLastARR.length - 1];
		delete const_var.defaultBuildingArr[findLastIndex];
	}

	if (const_var.defaultBuildingArr[action.defaultVal].building_id != action.value) {
		const_var.defaultBuildingJson = {};

		state.defaultBuilding = parseInt(action.defaultVal + 1);
		if (const_var.defaultBuildingArr[action.defaultVal + action.value] == undefined) {
			const_var.defaultBuildingJson.building_id = parseInt(action.value);
			const_var.defaultBuildingJson.id = parseInt(action.defaultVal + 1);
			state.defaultBuilding = parseInt(action.defaultVal + 1);
			const_var.defaultBuildingJson.default_doors = const_var.defaultBuildingArr[action.defaultVal].default_doors;
			const_var.defaultBuildingJson.image_name = const_var.defaultBuildingArr[action.defaultVal].image_name;
			const_var.defaultBuildingJson.leanto = const_var.defaultBuildingArr[action.defaultVal].leanto;
			const_var.defaultBuildingJson.leanto_size = const_var.defaultBuildingArr[action.defaultVal].leanto_size;
			const_var.defaultBuildingJson.leanto_wall = const_var.defaultBuildingArr[action.defaultVal].leanto_wall;

			const_var.defaultBuildingJson.central_roof_pitch = const_var.defaultBuildingArr[action.defaultVal].central_roof_pitch;
			const_var.defaultBuildingJson.leanto_roof_pitch = const_var.defaultBuildingArr[action.defaultVal].leanto_roof_pitch;
			const_var.defaultBuildingJson.leanto_data = const_var.defaultBuildingArr[action.defaultVal].leanto_data;
			const_var.defaultBuildingJson.wainscot_color = const_var.defaultBuildingArr[action.defaultVal].wainscot_color;

			const_var.defaultBuildingJson.manufacturer_id = const_var.defaultBuildingArr[action.defaultVal].manufacturer_id;
			const_var.defaultBuildingJson.name = const_var.defaultBuildingArr[action.defaultVal].name;
			const_var.defaultBuildingJson.other_building_id = const_var.defaultBuildingArr[action.defaultVal].other_building_id;
			const_var.defaultBuildingJson.roof_color = const_var.defaultBuildingArr[action.defaultVal].roof_color;
			const_var.defaultBuildingJson.roof_id = const_var.defaultBuildingArr[action.defaultVal].roof_id;
			const_var.defaultBuildingJson.trim_color = const_var.defaultBuildingArr[action.defaultVal].trim_color;
			const_var.defaultBuildingJson.utility = const_var.defaultBuildingArr[action.defaultVal].utility;
			const_var.defaultBuildingJson.utility_front = const_var.defaultBuildingArr[action.defaultVal].utility_front;
			const_var.defaultBuildingJson.wall = const_var.defaultBuildingArr[action.defaultVal].wall;
			const_var.defaultBuildingJson.wall_color = const_var.defaultBuildingArr[action.defaultVal].wall_color;

			let utilitySizes = const_var.defaultBuildingArr[action.defaultVal].size.split(",");
			if (const_var.defaultBuildingArr[action.defaultVal].name.includes("Utility Carports") && utilitySizes != undefined && utilitySizes.length > 1) {
				let utilityID = const_var.defaultBuildingArr[action.defaultVal].other_building_id.split(",");
				let find_Index = utilityID.findIndex((s, ind) => s == action.value);
				if (find_Index > 0 && action.value == utilityID[find_Index]) {
					const_var.defaultBuildingJson.size = utilitySizes[find_Index];
				}
			} else {
				const_var.defaultBuildingJson.size = const_var.defaultBuildingArr[action.defaultVal].size;
			}
			const_var.defaultBuildingJson.is_show = false;
			const_var.defaultBuildingJson.garageDoorColor = const_var.defaultBuildingArr[action.defaultVal].garageDoorColor;

			const_var.defaultBuildingArr[parseInt(action.defaultVal + 1)] = const_var.defaultBuildingJson;
		}
	}

	return {
		...state,
		newColor: action.value + action.defaultVal
	};
};
export const handleChangeBuildingData = (state, action, setBuildingData) => {
	state.defaultBuilding = undefined;
	state.checkedBuildingType = undefined;
	state.OlddefaultBuilding = undefined;
	state.const_var.defaultBuildingArr = [];
	state.const_var.newLeanArr = [];
	state.isFullyOpenedCheckedForFrontLeanTo = false;
	state.isFullyOpenedCheckedForBackLeanTo = false;
	state.isFullyOpenedCheckedForLeftLeanTo = false;
	state.isFullyOpenedCheckedForRightLeanTo = false;
	state.isFullyEnclosedChecked = false;
	state.isFullyEnclosedCheckedForLeftLeanTo = false;
	state.isFullyEnclosedCheckedForRightLeanTo = false;
	state.const_var.AllBuildingData = action.value;
	state.const_var.order_extra_items.engineer_drawings_name = "";
	state.const_var.order_extra_items.engineer_drawings = 0;
	cuComponent.removeAlltheComponent();
	if (action.value?.newBuildingData?.default_building) {
		loadDefaultBuilding(state, action.value?.newBuildingData?.default_building);
	} else {
		loadDefaultBuilding(state, const_var.defaultBuildingArr);
	}
	state.selectedTabKey = "buildingtypetab";

	const_var.callMesure = false;
	setBuildingData(state, action.value, state.defaulProductLoad, action.value, {
		makeDimensionUpdateBack,
		makeDimensionUpdateFront,
		makeDimensionUpdateLeft,
		makeDimensionUpdateRight
	});
	return {
		...state,
		newColor: action.value
	};
};
export const handleDefaultBuildingData = (state, action, setBuildingData) => {
	state.defaulProductLoad = true;
	  const data = action?.value?.data;
            const updatedData = {
                data: {
                    newBuildingData : data,
                    newBuildingColor : data?.color_data ?? data.color,
                    newBuildingMaterial : data?.siding_material_data ?? data.material,
                    default_building : data.default_building
                }
                
            }
	setBuildingData(state, updatedData.data, state.defaulProductLoad, updatedData.data, {
		makeDimensionUpdateBack,
		makeDimensionUpdateFront,
		makeDimensionUpdateLeft,
		makeDimensionUpdateRight
	});
	return {
		...state,
		newColor: action.value,
		defaulProductLoad: true
	};
};
export const handleSetDefaultConfiguration = (state, action, cuBuilding) => {
	if (action?.value?.request_data?.building?.display_building_type_name == "Custom Buildings") {
		state.const_var.checkmoreCustomizeFlag = true;
	}
	state.defaulProductLoad = true;
	state.selectedManufacturer = 0;

	if (state.const_var.crmSetting.is_Edit == true) {
		state.selectedTabKey = "buildsizes";
	} else {
		state.selectedTabKey = "buildingtypetab";
	}
	setDefaultConfiguration(state, action.value);
	cuBuilding.BuildingUpdate(true);
	if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
	if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
	if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
	if (params.add_back_lean == true) cuBuilding.UpdateBackLean();

	return {
		...state,
		newColor: action.value
	};
};

export const changeCenterBuilding = (state, action, cuBuilding) => {
	if (action.actionType == "action") {
		if (isNaN(params.oncenter_val) == true) {
			params.oncenter_val = 2;
		}
		params.oncenter_val_with_action = parseInt(params.oncenter_val);

		cuBuilding.BuildingUpdate(true);
		if (params.add_front_lean == true) cuBuilding.UpdateFrontLean();
		if (params.add_left_lean == true) cuBuilding.UpdateLeftLean();
		if (params.add_right_lean == true) cuBuilding.UpdateRightLean();
		if (params.add_back_lean == true) cuBuilding.UpdateBackLean();
	} else if (action.actionType == "selectvalue") {
		document.getElementById("distancecenter").select();
	} else {
		params.oncenter_val = parseInt(action.value);
	}
	return {
		...state,
		action
	};
};
export const handleBuildingStyleChange = (state, action, buildingStyleChange) => {
	state.micro_loader = true;

	params.toggleBuildingStyleChange = !params.toggleBuildingStyleChange;
	state.selectedTabstate = "hidestatebox";
	params.is_translusant = false;
	// ########## for resetting cc fees variables ##########
	const_var.card_processing_fee.is_edit = undefined;
	const_var.is_edit_labour = undefined;

	buildingStyleChange(state, action.value, action.shouldNotResetisLTBuildingFlag);

	if (const_var.focusedSection !== "") {
		const_var.scene.traverse((child) => {
			if (child.type === "Mesh") {
				child.material.transparent = false;
				child.material.opacity = 1;
				child.material.depthWrite = true;
			}
			if (
				child.name == "frontWallWaterMark" ||
				child.name == "backWallWaterMark" ||
				child.name == "usSteelbuildingCenterGround" ||
				child.name == "eagleLogo" ||
				child.name == "manufacturerLogoFront" ||
				child.name == "manufacturerLogoBack" ||
				child.name == "manufacturerLogoCenter"
			) {
				child.material.transparent = true;
				child.material.opacity = 1;
				child.material.depthWrite = true;
			}
		});
		const_var.focusedSection = "";
	}

	return {
		...state,
		newColor: action.value
	};
};
export const handleBuildingStyleTypeChange = (state, action) => {
	const_var.isOverhang = {
		end: {
			isChecked: false,
			selected: "",
			size: 0.5
		},
		side: {
			isChecked: false,
			selected: "",
			size: 0.5
		},
		both: {
			isChecked: false,
			selected: "",
			size: 0.5
		}
	};

	params.is_translusant = false;

	const_var.card_processing_fee.is_edit = undefined;
	const_var.is_edit_labour = undefined;

	if (action.value == undefined) {
		const_var.isShowbuildingtype = false;
		state.defaultBuilding = state.defaultBuilding;
		state.checkedBuildingType = state.checkedBuildingType;
		state.OlddefaultBuilding = state.OlddefaultBuilding;
	} else {
		if (action.othertype.length > 1) {
			state.defaultBuilding = action.value;
			state.OlddefaultBuilding = action.value;
			state.const_var.isShowbuildingtypeArr = action.othertype;

			let filterBuildingId = const_var.defaultBuildingArr[state.defaultBuilding].building_id;
			if (state.checkedBuildingType != undefined && action.othertype.includes(state.checkedBuildingType) != true) {
				if (const_var.ExtraBuildingID[filterBuildingId] && const_var.ExtraBuildingID[filterBuildingId].name?.includes("/12")) {
					const_var.otherBuildingRoofPitch = const_var.ExtraBuildingID[filterBuildingId].name.split("/12")[0];
				}
				state.checkedBuildingType = filterBuildingId;
			}

			const_var.isShowbuildingtype = true;
			if (state.const_var.selectedTabKeyForWheel == "buildsizes") {
				const_var.isShowbuildingtype = false;
				document.querySelector("body").classList.remove("active-modal-loader");
			}
		}
	}

	return {
		...state,
		newColor: action.value + action.othertype + const_var.isShowbuildingtype
	};
};
export const handleBuildingFlag = (state, action) => {
	if (action.key == "center") {
		const_var.commonBuildingFlag.center.buildingHeight = !const_var.commonBuildingFlag.center.buildingHeight;
		if (!const_var.commonBuildingFlag.center.buildingHeight) {
			const_var.commonBuildingFlag.center.buildingHeightChk = true;
		}
	}
	if (action.key == "leftLean") {
		const_var.commonBuildingFlag.leftLean.leftLeanHeight = action.exactValue;
		if (!const_var.commonBuildingFlag.leftLean.leftLeanHeight == false) {
			const_var.commonBuildingFlag.leftLean.leftLeanHeightChk = true;
		}
	}
	if (action.key == "frontLean") {
		const_var.commonBuildingFlag.frontLean.frontLeanHeight = action.exactValue;
		if (!const_var.commonBuildingFlag.frontLean.frontLeanHeight == false) {
			const_var.commonBuildingFlag.frontLean.frontLeanHeightChk = true;
		}
	}
	if (action.key == "backLean") {
		const_var.commonBuildingFlag.backLean.backLeanHeight = action.exactValue;
		if (!const_var.commonBuildingFlag.backLean.backLeanHeight == false) {
			const_var.commonBuildingFlag.backLean.backLeanHeightChk = true;
		}
	}
	if (action.key == "rightLean") {
		const_var.commonBuildingFlag.rightLean.rightLeanHeight = action.exactValue;
		if (!const_var.commonBuildingFlag.rightLean.rightLeanHeight == false) {
			const_var.commonBuildingFlag.rightLean.rightLeanHeightChk = true;
		}
	}
	if (action.key == "addWrap") {
		const_var.commonBuildingFlag.wrap = !const_var.commonBuildingFlag.wrap;
	}
	if (action.key == "premiumcolor") {
		const_var.commonBuildingFlag.premiumcolor = !const_var.commonBuildingFlag.premiumcolor;
	}
	if (action.key == "premiumcolorClose") {
		const_var.commonBuildingFlag.premiumcolor = false;
	}

	return {
		...state,
		action
	};
};
export const handleShowCenterBuilding = (state, action, cuBuilding) => {
	params.isShowCenter = !params.isShowCenter;
	if (params.isShowCenter == true && params.add_left_lean == true && params.activeWall == "L_L_L_W") {
		params.activeWall = "c_b_l_w";
	}
	if (params.isShowCenter == false && params.add_left_lean == true && params.activeWall == "c_b_l_w") {
		params.activeWall = "L_L_L_W";
	}

	if (params.isShowCenter == true && params.add_right_lean == true && params.activeWall == "R_L_R_W") {
		params.activeWall = "c_b_r_w";
	}
	if (params.isShowCenter == false && params.add_right_lean == true && params.activeWall == "c_b_r_w") {
		params.activeWall = "R_L_R_W";
	}

	if (params.isShowCenter == true && params.add_front_lean == true && params.activeWall == "F_L_F_W") {
		params.activeWall = "c_b_f_w";
	}
	if (params.isShowCenter == false && params.add_front_lean == true && params.activeWall == "c_b_f_w") {
		params.activeWall = "F_L_F_W";
	}

	if (params.isShowCenter == true && params.add_back_lean == true && params.activeWall == "B_L_S_W") {
		params.activeWall = "c_b_b_w";
	}
	if (params.isShowCenter == false && params.add_back_lean == true && params.activeWall == "c_b_b_w") {
		params.activeWall = "B_L_S_W";
	}

	const_var.focusedSection = "center";
	const_var.wallSelection.centerBuildingWall = params.activeWall;
	const_var.wallSelection.leanToWall = "select";
	state.doorWindowIconsPos = [];
	if (const_var.callMesure) {
	}
	cuBuilding.BuildingUpdate(true, action.value);
	cuBuilding.UpdateFrontLean();
	cuBuilding.UpdateLeftLean();
	cuBuilding.UpdateRightLean();
	cuBuilding.UpdateBackLean();

	return {
		...state,
		showCenterBuilding: action
	};
};
export const handleTrussChange = (state, action, cuBuilding) => {
	state.params.trussType = action.value.replace(/[0-9]/g, "");
	state.params.newtrussType = action.value.replace(/[0-9]/g, "");
	const_var.post_data["building"].edit_truss_name = state.params.trussType;
	const_var.UpdatedPriceData.truss_price_changed = true;
	let filterDataTruss = const_var.a_p_d_a.truss_name.filter((data) => data.name.includes(const_var.post_data["building"].edit_truss_name));
	if (filterDataTruss.length > 0) {
		const_var.post_data["building"].truss_type_name =
			filterDataTruss[0].is_default == true
				? "Standard Truss"
				: state.params.m_s_n == 153
					? filterDataTruss[0] != undefined && filterDataTruss[0].label != undefined && filterDataTruss[0].label != null
						? filterDataTruss[0].label
						: "Ladder Truss"
					: filterDataTruss[0] != undefined && filterDataTruss[0].label != undefined && filterDataTruss[0].label != null
						? filterDataTruss[0].label
						: "High Truss";
	}
	cuBuilding.BuildingUpdate(true, "");
	cuBuilding.cP();
	return {
		...state,
		newColor: action.value + const_var.post_data["building"].edit_truss_name + new Date()
	};
};

export const changeBuildingTypeName = (state, action) => {
	let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;

	params.other_building_type_name = action.value;
	params.checkeditName = true;
	if (const_var.post_data.building != undefined) {
		const_var.post_data.building.other_building_type_name = params.other_building_type_name;
		const_var.post_data.building.name = params.other_building_type_name;
	}
	return {
		...state,
		changeOtherBuildingTypeName: action
	};
};

export const selectCenterBuilding = (state, action, utils) => {
	const_var.selectedLeanType = "";
	const_var.a_p_d_a = JSON.parse(JSON.stringify(const_var.holdPricingResponse));
	makeDimensionArray(state);
	params.activeWall = "c_b_f_w";
	cuComponent.cameraFocusOnWall(state, "c_b_f_w");
	utils.updateCPAccordingToLNTBuilding();
	utils.restoreUpdatedPriceDataElements();
	state.const_var.isCBSelected = true;
	const_var.isCBSelected = true;
	return {
		...state,
		action: action + const_var.a_p_d_a + Math.random()
	};
};
export const fullBuildingView = (state, action) => {
	if (const_var.isShowEditConfigurationButton == false && const_var.crmSetting.is_quote_Edit == true) {
		return;
	}

	const removea = document.querySelector("body");

	state.isfullviewbuilding = !state.isfullviewbuilding;

	if (state.isfullviewbuilding) {
		removea.classList.add("active-fullview");
	} else {
		removea.classList.remove("active-fullview");
	}

	cuComponent.onResize();

	return {
		...state,
		action
	};
};
export const fullWrapClick = (state, action) => {
	state.params.add_full_lean_porch = action.key;
	if (state.params.add_full_lean_porch == true) {
		params.leanR_p_pos = 0;
		params.lean_p_pos = 0;
		params.leanF_p_pos = 0;
		params.leanB_p_pos = 0;
		params.lean_p_d = params.p_d;
		params.leanR_p_d = params.p_d;
		params.leanF_p_d = params.p_w;
		params.leanB_p_d = params.p_w;
	}

	return {
		...state,
		action
	};
};
export const handleToggleCheckbox = (state, action) => {
	if (action.key == "centerBuilding") {
		const_var.setSidesEndsWallOption = "partial";
	}
	if (action.key == "frontLeanto") {
		const_var.setLeanWallOption.frontLean = "partial";
	}
	if (action.key == "backLeanto") {
		const_var.setLeanWallOption.backLean = "partial";
	}
	if (action.key == "leftLeanto") {
		const_var.setLeanWallOption.leftLean = "partial";
	}
	if (action.key == "rightLeanto") {
		const_var.setLeanWallOption.rightLean = "partial";
	}
	return {
		...state,
		action
	};
};
export const handleKLinkExpire = (state, action) => {
	if (action.value == false) {
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "ManageKlinkMessage";
	} else {
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "ManageKlinkExpire";
		const_var.alertExpireMessage = action.value;
	}

	if (state.const_var.isShowAlert == true) {
		document.querySelector("body").classList.remove("active-state-screen");
	}

	return {
		...state,
		newColor: action.value + state.const_var.isShowAlert + state.const_var.alertUsedFor + const_var.alertExpireMessage
	};
};
export const handleUpdatePostdata = (state, action) => {
	delete state.const_var.post_data.full_name;
	delete state.const_var.post_data.first_name;
	delete state.const_var.post_data.last_name;
	delete state.const_var.post_data.email;
	delete state.const_var.post_data.phone_no;
	delete state.const_var.zipCode;
	delete state.const_var.billing_address_line_1;
	delete state.const_var.billing_zipcode;
	delete state.const_var.shipping_zipcode;

	if (state.const_var.post_data.address && state.const_var.post_data.address.length > 0) {
		delete state.const_var.post_data.address[0].zipcode;
		delete state.const_var.post_data.address[0].address_line_1;
	}
	return {
		...state,
		action
	};
};
export const handleSetupTween = (state, action, TWEEN) => {
	var cam = const_var.camera.position;
	var contro = const_var.controls.target;
	var xTarget = 0;
	var yTarget = params.p_h / 2;
	var zTarget = 1.25 * state.params.p_d;
	var tweenDuration = 2500;
	const_var.tween = true;
	TWEEN.removeAll();
	var camNewPosition = { x: xTarget, y: yTarget, z: zTarget };
	var targetNewPos = { x: xTarget, y: yTarget, z: 0 };
	var camTween = new TWEEN.Tween(cam).to(camNewPosition, tweenDuration).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
	var targetTween = new TWEEN.Tween(contro).to(targetNewPos, tweenDuration).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();

	return {
		...state,
		action
	};
};
export const SetPricingForComponent = (state, action, cuBuilding) => {
	state.newColor = action.id + action.flag;

	const_var.callFromDoorAddOrRemove = true;

	if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0 && action.is_editChk != true) {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	cuBuilding.cP("", undefined, action.indexVal, action.chk, action.is_editChk);

	return {
		...state,
		action
	};
};
export const handleSetFramevalue = (state, action) => {
	state.params.chkFrameOpening = !state.params.chkFrameOpening;
	if (state.params.chkFrameOpening == true) {
		if (action.dropdownType == "WidthHeight") {
			action.comName = "CustomGarageSize";
			const_var.editComponentDimension = "CustomGarageSize";
			params.customW = 5;
			params.customH = 5;
		}
	} else {
		const_var.editComponentDimension = const_var.customFrameoutInitialSize + "_Frameout";
	}
	return {
		...state,
		action
	};
};
export const showSingleSlope = (state, action, cuBuilding) => {
	if (action.key == true) {
		state.params.singleSlope = !state.params.singleSlope;
		cuBuilding.BuildingUpdate(true, "centerwall");
	} else {
		params.p_l_w_center = !params.p_l_w_center;
	}

	return {
		...state,
		newColor: state.params.singleSlope
	};
};
export const handleShowSummary = (state, action) => {
	state.params.m_s_n_1 = "";
	state.params.m_s_n_2 = "";
	state.params.m_n_f_1 = "";
	state.params.m_n_f_2 = "";
	state.selectedManufacturer = 0;
	state.isShowSummaryModal = !state.isShowSummaryModal;

	return {
		...state,
		action
	};
};
export const handleDeleteStateModal = (state, action) => {
	state.isShowDeletedStateManuModal = action.value;

	if (document.querySelector("body").classList.contains("active-modal-loader")) {
		document.querySelector("body").classList.remove("active-modal-loader");
	}
	state.const_var.is_loader = false;

	return {
		...state,
		newColor: action.value
	};
};
export const checkRoofPitch = (previousRoofPitch = undefined, leanType = undefined, data = undefined) => {
	previousRoofPitch = previousRoofPitch != undefined ? previousRoofPitch + "/12" : undefined;
	let p_r_p = params.p_r_p + "/12";
	if ((previousRoofPitch == undefined || previousRoofPitch != p_r_p) && leanType == undefined) {
		let extraAddOnItemsArray = const_var.isLTBuilding ? const_var.lNTBuildingData?.extraAddOnItemsArray?.centerBuilding : const_var.extraAddOnItemsArray;
		if (previousRoofPitch != undefined) {
			let findIndex = -1;
			if (extraAddOnItemsArray.length > 0) {
				findIndex = extraAddOnItemsArray.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == previousRoofPitch);
			}
			if (findIndex > -1) {
				extraAddOnItemsArray[findIndex]["is_checked"] = false;
				extraAddOnItemsArray[findIndex]["is_disabled"] = false;
			}
		}
		let findResIndex = -1;
		if (extraAddOnItemsArray.length > 0) {
			extraAddOnItemsArray.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == p_r_p);
		}
		if (findResIndex > -1) {
			extraAddOnItemsArray[findResIndex]["is_checked"] = true;
			extraAddOnItemsArray[findResIndex]["is_disabled"] = true;
		} else {
		}
		if (const_var.isLTBuilding) {
			const_var.lNTBuildingData.extraAddOnItemsArray.centerBuilding = extraAddOnItemsArray;
		} else {
			const_var.extraAddOnItemsArray = extraAddOnItemsArray;
		}
	}

	if (leanType != undefined) {
		if (leanType == "front") {
			p_r_p = params.b_l_t_r_pF + "/12";
			if (previousRoofPitch == undefined || previousRoofPitch != p_r_p) {
				if (previousRoofPitch != undefined) {
					let findIndex = -1;
					if (const_var.lNTBuildingData?.extraAddOnItemsArray?.front?.length > 0) {
						findIndex = const_var.lNTBuildingData.extraAddOnItemsArray.front.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == previousRoofPitch);
					}
					if (findIndex > -1) {
						const_var.lNTBuildingData.extraAddOnItemsArray.front[findIndex]["is_checked"] = false;
						const_var.lNTBuildingData.extraAddOnItemsArray.front[findIndex]["is_disabled"] = false;
					}
				}
				let findResIndex = -1;
				if (const_var.lNTBuildingData?.extraAddOnItemsArray?.front?.length > 0) {
					findResIndex = const_var.lNTBuildingData?.extraAddOnItemsArray.front.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == p_r_p);
				}
				if (findResIndex > -1) {
					const_var.lNTBuildingData.extraAddOnItemsArray.front[findResIndex]["is_checked"] = true;
					const_var.lNTBuildingData.extraAddOnItemsArray.front[findResIndex]["is_disabled"] = true;
				} else {
					let currIndex = -1;
				}
			}
		}
		if (leanType == "back") {
			p_r_p = params.b_l_t_r_pB + "/12";
			if (previousRoofPitch == undefined || previousRoofPitch != p_r_p) {
				if (previousRoofPitch != undefined) {
					let findIndex = -1;
					if (const_var.lNTBuildingData?.extraAddOnItemsArray?.back?.length > 0) {
						findIndex = const_var.lNTBuildingData.extraAddOnItemsArray.back.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == previousRoofPitch);
					}
					if (findIndex > -1) {
						const_var.lNTBuildingData.extraAddOnItemsArray.back[findIndex]["is_checked"] = false;
						const_var.lNTBuildingData.extraAddOnItemsArray.back[findIndex]["is_disabled"] = false;
					}
				}
				let findResIndex = -1;
				if (const_var.lNTBuildingData?.extraAddOnItemsArray?.back?.length > 0) {
					findResIndex = const_var.lNTBuildingData?.extraAddOnItemsArray.back.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == p_r_p);
				}
				if (findResIndex > -1) {
					const_var.lNTBuildingData.extraAddOnItemsArray.back[findResIndex]["is_checked"] = true;
					const_var.lNTBuildingData.extraAddOnItemsArray.back[findResIndex]["is_disabled"] = true;
				} else {
					let currIndex = -1;
				}
			}
		}
		if (leanType == "left") {
			p_r_p = params.b_l_t_r_p + "/12";
			if (previousRoofPitch == undefined || previousRoofPitch != p_r_p) {
				if (previousRoofPitch != undefined) {
					let findIndex = -1;
					if (const_var.lNTBuildingData?.extraAddOnItemsArray?.left?.length > 0) {
						findIndex = const_var.lNTBuildingData.extraAddOnItemsArray.left.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == previousRoofPitch);
					}
					if (findIndex > -1) {
						const_var.lNTBuildingData.extraAddOnItemsArray.left[findIndex]["is_checked"] = false;
						const_var.lNTBuildingData.extraAddOnItemsArray.left[findIndex]["is_disabled"] = false;
					}
				}
				let findResIndex = -1;
				if (const_var.lNTBuildingData?.extraAddOnItemsArray?.left?.length > 0) {
					findResIndex = const_var.lNTBuildingData?.extraAddOnItemsArray.left.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == p_r_p);
				}
				if (findResIndex > -1) {
					const_var.lNTBuildingData.extraAddOnItemsArray.left[findResIndex]["is_checked"] = true;
					const_var.lNTBuildingData.extraAddOnItemsArray.left[findResIndex]["is_disabled"] = true;
				} else {
				}
			}
		}
		if (leanType == "right") {
			p_r_p = params.b_l_t_r_pR + "/12";
			if (previousRoofPitch == undefined || previousRoofPitch != p_r_p) {
				if (previousRoofPitch != undefined) {
					let findIndex = -1;
					if (const_var.lNTBuildingData?.extraAddOnItemsArray?.right?.length > 0) {
						findIndex = const_var.lNTBuildingData.extraAddOnItemsArray.right.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == previousRoofPitch);
					}
					if (findIndex > -1) {
						const_var.lNTBuildingData.extraAddOnItemsArray.right[findIndex]["is_checked"] = false;
						const_var.lNTBuildingData.extraAddOnItemsArray.right[findIndex]["is_disabled"] = false;
					}
				}
				let findResIndex = -1;
				if (const_var.lNTBuildingData?.extraAddOnItemsArray?.right?.length > 0) {
					findResIndex = const_var.lNTBuildingData?.extraAddOnItemsArray.right.findIndex((obj) => obj?.roof_pitch && obj.roof_pitch == p_r_p);
				}
				if (findResIndex > -1) {
					const_var.lNTBuildingData.extraAddOnItemsArray.right[findResIndex]["is_checked"] = true;
					const_var.lNTBuildingData.extraAddOnItemsArray.right[findResIndex]["is_disabled"] = true;
				} else {
				}
			}
		}
	}
};
